import Vue from 'vue'
import VueI18n from "vue-i18n"

Vue.use(VueI18n)

import fr from '../locales/fr'


export default new VueI18n({
    locale: 'fr',
    messages: {
        fr
    },
    fallbackLocale: 'fr'
})